

module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_ie8-dom-define.js
// module id = ../node_modules/core-js/modules/_ie8-dom-define.js
// module chunks = 0